<template>
  <div class="supplier body">
    <el-container>
      <!-- <PayAside /> -->
      <el-main>
        <el-row class="search" :gutter="10" align="center">
          <el-col :span="14">
            <div class="bg-white">
              <label for="searchForCustomer">اختر اسم العميل</label>
              <el-input v-model="search" placeholder="بحث العملاء"> </el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="bg-white">
              <label for="balnceFrom">المديونيه من</label>
              <el-input
                v-model="balnceFrom"
                type="number"
                placeholder="حساب العميل"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="bg-white">
              <label for="balnceTo">المديونيه الي</label>
              <el-input
                v-model="balnceTo"
                type="number"
                placeholder="حساب العميل"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="2">
            <el-button
              type="success"
              title="طباعه"
              icon="el-icon-printer"
              @click="sendToPrintAll()"
              class="mt-5"
            ></el-button>
          </el-col>
        </el-row>
        <el-row class="cInfo">
          <el-col :span="24">
            <div class="bg-white">
              <div class="headerSide bg-green">
                <p class="text">حركه العملاء / حركه المدينين</p>
                <p class="num">
                  <span>{{ numberToFixed(totalAccounts) }}</span> ج.م
                </p>
              </div>
              <div class="content">
                <Customers :customers="customers" :btnColor="'bgGreen'" />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import PayAside from "@/components/PayAside.vue";
import Customers from "@/components/Pay/Customers.vue";
// import Customers from "@/components/Pay/CustomersCopy.vue";
import axiosApi from "@/plugins/axios.js";
// import { ipcRenderer } from "electron";

export default {
  components: {  Customers },
  data() {
    return {
      search: "",
      customers: [],
      allCustomers: [],
      totalAccounts: 0,
      balnceFrom: "",
      balnceTo: "",
    };
  },
  created() {
    this.getCustomers();
  },
  watch: {
    search: function (newValue) {
      this.customers = this.allCustomers;

      let query = newValue.trim();
      if (query != "") {
        this.customers = this.customers.filter((customer) => {
          return (
            customer.name.toLowerCase().includes(query.toLowerCase()) ||
            (customer.phone &&
              customer.phone.toLowerCase().includes(query.toLowerCase()))
          );
        });
      } else {
        this.customers = this.allCustomers;
      }
      this.calcTotalAcounts();
    },
    balnceFrom: function (newValue) {
      this.customers = this.allCustomers;
      let balance = newValue.trim();
      if (balance != "") {
        this.customers = this.customers.filter((customer) => {
          return (
            Number(customer.account) + Number(customer.balance) >=
              Number(balance) &&
            Number(customer.account) + Number(customer.balance) <=
              Number(this.balnceTo)
          );
        });
      } else {
        this.customers = this.allCustomers;
      }
      this.calcTotalAcounts();
    },
    balnceTo: function (newValue) {
      this.customers = this.allCustomers;
      let balance = newValue.trim();
      if (balance != "") {
        this.customers = this.customers.filter((customer) => {
          return (
            Number(customer.account) + Number(customer.balance) <=
              Number(balance) &&
            Number(customer.account) + Number(customer.balance) >=
              Number(this.balnceFrom)
          );
        });
      } else {
        this.customers = this.allCustomers;
      }
      this.calcTotalAcounts();
    },
  },
  methods: {
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    getCustomers() {
      // customers/to-pay
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let url = `customers-balance`;
      axiosApi
        .get(url)
        .then((response) => {
          this.customers = response.data;
          this.allCustomers = response.data;
          this.calcTotalAcounts();
          setTimeout(() => {
            document.querySelector(".paied").focus();
          }, 200);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
        });
    },
    calcTotalAcounts() {
      let sum = 0;
      this.customers.map((customer) => {
        customer["paied"] = "";
        //  console.log("customer['balance']+customer['account']",customer['balance']+customer['account'])
        sum += Number(customer["balance"]) + Number(customer["account"]);
      });
      this.totalAccounts = sum;
    },
    sendToPrintAll() {
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: { customers: this.customers, totalAccounts: this.totalAccounts },
      //   type: "CustomerTraffic",
      //   customer: true,
      //   title: "كشف حساب العملاء",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
  },
};
</script>
<style lang="sass">
@import "../../styles/Pay.scss"
</style>
